/* unplugin-vue-components disabled */import { render } from "./Grid.vue?vue&type=template&id=63b51ca7&ts=true"
import script from "./Grid.vue?vue&type=script&lang=ts"
export * from "./Grid.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__